import { planFeedbackTransactionActionType } from './../../builders/plan_feedback_transaction_type';
import { APFeedbackLinkedSuggestionsQuery } from './../../queries/feedback_linked_suggestions_query';
class LinkedSuggestionActionPopup {
  private isOpened = true;
  constructor(
    private $state: any,
    private $element: ng.IAugmentedJQuery,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any,
    private ngAPFeedbackLinkedSuggestionsQuery: APFeedbackLinkedSuggestionsQuery,
    private feedbackAcceptDeclineRevokeHelper: any
  ) {}

  openedChanged() {
    this.$state.__goToPrevious__();
    this.phxFocusDelegate.focus(this.phxAxReturnFocusFactory.getFocusId());
  }

  performActionOnSuggestions(action: planFeedbackTransactionActionType) {
    this.feedbackAcceptDeclineRevokeHelper(this.ngAPFeedbackLinkedSuggestionsQuery.result.suggestions, action).then(
      () => {
        this.closeModal();
      }
    );
  }

  acceptAllClicked() {
    this.performActionOnSuggestions('ACCEPT');
  }

  declineAllClicked() {
    this.performActionOnSuggestions('REJECT');
  }
  closeModal() {
    this.isOpened = false;
  }
}

angular.module('capability-ng-academic-planner').component('linkedSuggestionActionPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/linked_suggestions_action_popup/linked_suggestions_action_popup.html',
  controller: LinkedSuggestionActionPopup
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/linked_suggestions_action_popup/linked_suggestions_action_popup.ts